// export const environment = {
//   production: false,
//   apiUrl: "http://localhost:3000/api/",
//   apiSocketUrl: "http://localhost:3000/",
//   apiUrlAuth: "http://localhost:3000/auth"
// };

export const environment = {
  production: true,
  apiUrl: "https://api-loja.rxplay.com.br/api/",
  apiSocketUrl: "https://api-loja.rxplay.com.br/",
  apiUrlAuth: "https://api-loja.rxplay.com.br/auth"
};
